import React, { Suspense, lazy } from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { TruckLocation } from '../../types/dashboard.type';

// Lazy load the map component
const MapComponent = lazy(() => import('./MapComponent'));

interface TruckMapProps {
  trucks: TruckLocation[];
  /** Map height in pixels (defaults to 500). */
  height?: number;
}

const TruckMap: React.FC<TruckMapProps> = ({ trucks, height = 500 }) => {
  const theme = useTheme();

  // Calculate center point of all trucks
  const center = trucks.length > 0
    ? {
        lat: trucks.reduce((sum, truck) => sum + truck.latitude, 0) / trucks.length,
        lng: trucks.reduce((sum, truck) => sum + truck.longitude, 0) / trucks.length,
      }
    : { lat: 24.7136, lng: 46.6753 }; // Default to Riyadh

  return (
    <Box
      sx={{
        height,
        width: '100%',
        borderRadius: 1,
        overflow: 'hidden',
        border: `1px solid ${theme.palette.divider}`,
        boxShadow: theme.shadows[3],
        position: 'relative',
        zIndex: 0,
      }}
    >
      <Suspense
        fallback={
          <Box
            sx={{
              height: '100%',
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography>Loading map...</Typography>
          </Box>
        }
      >
        <MapComponent trucks={trucks} center={center} />
      </Suspense>
    </Box>
  );
};

export default TruckMap;
